import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { SharedModule } from "../../../components/shared/shared.module";

// ------------------------------------------Start Service----------------------------------------------------------------------//
import { BsDropdownModule, CollapseModule, ModalModule } from "ngx-bootstrap";
import { PipeModule } from "../../../pipe/pipe.module";
import { BuilkSharedModule } from "../shared/shared.module";
import { LoadingModule } from "ngx-loading";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgbModule, NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { BsDatepickerModule, PaginationModule } from "ngx-bootstrap";

// ------------------------------------------End Service----------------------------------------------------------------------//

//component
import { PackageSaleComponent } from "./package-sale.component";
import { AddQuotationModalComponent } from "./add-quotation-modal/add-quotation-modal.component";

@NgModule({
  declarations: [
    PackageSaleComponent,
    AddQuotationModalComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    BrowserModule,
    RouterModule,
    SharedModule,
    BsDropdownModule.forRoot(),
    CollapseModule.forRoot(),
    ModalModule.forRoot(),
    NgbModule.forRoot(),
    PipeModule,
    BuilkSharedModule,
    LoadingModule,
    NgSelectModule,
    NgbDropdownModule,
    BsDatepickerModule.forRoot(),
    PaginationModule,
    ReactiveFormsModule
  ],
  exports: [
    PackageSaleComponent,
  ]
})
export class PackageSaleModule { }
